exports.version = "2.3.0"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 389
// module chunks = 0